import React, { useRef, useState } from "react";
import { message } from "antd";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { IYhFormRef, IYhForm, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { useBillCreateModel } from "./billCreateModel";
import { ioFlagDs, partnerTypeDs, tradeTypeCreateBillDs, tradeTypeDs } from "@/types/FmsDs";
import { fn, useGlobalModel } from "@/model/globalModel"
import { cashService } from "@/views/cash/CashService";
import { OptionDsType } from "@/types/FmsTypes";
import { useAccountModel } from "@/views/account/customer/view/detail/account/accountModel";
import { format } from "util";
import { BillPayTypeEnum, TradeTypeEnum, UserTypeEnum } from "@/types/FmsEnums";
import { billService } from "../BillService";

export const CreateCustomerBillDrawer = () => {

    const {
        appDs, beDs, orgDs, payMethodDs,
        createCustomerBillDrawerVisible,
        setCreateCustomerBillDrawerVisible,
        loadData,
    } = useBillCreateModel(model => [model.createCustomerBillDrawerVisible]);



    const [accountDs, setAccountDs] = useState<OptionDsType[]>([]) //实时存取收款账户类型值

    const { user, fetchCustomerList, fetchSupplierList, shopDs, } = useGlobalModel()
    const [formData, setFormData] = useState<any>({
        tradeOperator: user.userName,
        partnerTypeCode: UserTypeEnum.CUSTOMER,
    })


    // 根据收款方式查询账户类型
    const queryAccount = async (partnerCode: string) => {
        let params = {
            partnerCode,
            // accountTypeCode,
            sourceApp: "fms",
            // beCode: selectedData?.beCode
        }
        let { retData } = await cashService.accountFind(params)
        setAccountDs(retData.map(item => ({ label: item.name, value: item.code })))
    }


    const shelfFocus = () => {
        const form = formRef.current?.getFieldsValue()
        console.log(form)
        setFormData(formData)

        if (form.partnerCode) {
            queryAccount(form.partnerCode)
        } else {
            setAccountDs([]);
        }
    }

    // const partnerCodeOptions = () => {
    //     if (createParterType === UserTypeEnum.CUSTOMER) return fetchCustomerList
    //     if (createParterType === UserTypeEnum.SUPPLIER) return fetchSupplierList
    //     return fn
    // }

    const formRef = useRef<IYhFormRef>();

    const onOk = async () => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                const shop = shopDs.find(item => item.value === formData.shopCode)
                const data = {
                    ...formData,
                    payType: BillPayTypeEnum.BALANCE,
                    shopName: shop?.label,
                    shopCode: shop?.code,
                    // orgName: orgDs?.find(item => item.),
                }
                let insertRet = await billService.insertTemp(data);
                if (insertRet.retData) {
                    message.success("新增成功!");
                    loadData({ pageNum: 1 }).then()
                    setCreateCustomerBillDrawerVisible(false);
                } else {
                    message.success("调额失败!" + insertRet.retMsg);
                }
            }
        } catch (e) {
            console.log("数据校验失败");
        }
    }
    const onCancel = () => {
        setCreateCustomerBillDrawerVisible(false);
    };
    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        disabled: false,
        formValues: formData,
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "系统分支",
                fieldName: "branch",
                ds: appDs,
                // disable: true,
                span: 12,
                rules: [{ required: true, message: '系统分支为必填项' }]
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "组织结构",
            //     fieldName: "orgName",
            //     // disable: true,
            //     span: 12,
            // },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "组织结构",
                fieldName: "orgCode",
                treeData: orgDs,
                // disable: true,
                span: 12,
                // rules: [{ required: true, message: '组织结构为必填项' }]
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "实体",
            //     fieldName: "beName",
            //     // disable: true,
            //     span: 12,
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "实体",
                fieldName: "beCode",
                ds: beDs,
                // disable: true,
                span: 12,
                rules: [{ required: true, message: '实体为必填项' }]
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "客户名称",
            //     fieldName: "partnerName",
            //     // disable: true,
            //     span: 12,
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "合作类型编码",
                fieldName: "partnerTypeCode",
                ds: partnerTypeDs,
                disable: true,
                span: 12,
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "客户名称",
                fieldName: "partnerCode",
                selectfetchList: fetchCustomerList,
                span: 12,
                rules: [{ required: true, message: '客户名称为必填项' }]
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "账户名称",
            //     fieldName: "accountName",
            //     // disable: true,
            //     span: 12,
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "账户名称",
                fieldName: "accountCode",
                ds: accountDs,
                onSelectFocus: shelfFocus,
                // onSelectFocus: shelfFocus,
                // disable: true,
                span: 12,
                rules: [{ required: true, message: '账户为必填项' }]
                // render: (v: string, record: any) => record.accountName || '请选择收款账户'
            },
            // {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: "门店名称",
            //     fieldName: "shopName",
            //     // disable: true,
            //     span: 12,
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "门店",
                fieldName: "shopCode",
                ds: shopDs,
                // disable: true,
                span: 12,
                rules: [{ required: true, message: '门店为必填项' }]
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "业务单据编码",
            //     fieldName: "tradeCode",
            //     // ds: dictSource
            //     // disable: true,
            //     span: 12,
            // },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "交易人员",
                fieldName: "tradeOperator",
                disable: true,
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账单金额",
                fieldName: "billAmount",
                // disable: true,
                span: 12,
                rules: [{ required: true, message: '账单金额为必填项' }]
            },
            // {
            //     type: FormItemTypeEnum.TreeSelect,
            //     fieldLabel: "结算方式编码",
            //     fieldName: "payMethodCode",
            //     treeData: payMethodDs,
            //     // disable: true,
            //     span: 12,
            //     rules: [{ required: true, message: '结算方式为必填项' }]
            // },
            // {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: "优惠类型",
            //     fieldName: "preferentialTypeName",
            //     // disable: true,
            //     span: 12,
            // },
            // {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: "优惠类型",
            //     fieldName: "preferentialTypeCode",
            //     // disable: true,
            //     span: 12,
            // },

            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "交易类型",
                fieldName: "tradeTypeCode",
                ds: tradeTypeCreateBillDs,
                // disable: true,
                span: 12,
                rules: [{ required: true, message: '交易类型为必填项' }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "收支类型",
                fieldName: "ioFlag",
                ds: ioFlagDs,
                // disable: true,
                span: 12,
                rules: [{ required: true, message: '收支类型为必填项' }]
            },
            {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "备注",
                fieldName: "note",
                // ds: payTypeOption,
                // disable: true,
                span: 24,
                labelCol: { span:3 },
                rows: 3,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "支付类型",
                fieldName: "payType",
                // ds: payTypeOption,
                // disable: true,
                hidden: true,
                span: 12,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "支付类型",
                fieldName: "payType",
                // ds: payTypeOption,
                // disable: true,
                hidden: true,
                span: 12,
            },

        ]
    };
    return (
        <AppDrawer
            {...{
                title: "新增账单",
                visible: createCustomerBillDrawerVisible,
                width: 1000,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <YhForm formRef={formRef} {...formConfig}  />
        </AppDrawer>
    )
}
